import request from '@/utils/request'
//purpose=2 used for follow account.
export function getWeChatQRCode(sceneStr, purpose = 2) {
  return request({
    url: '/api/WeChatLogin/qr',
    method: 'GET',
    params: {
      sceneStr,//current user openid
      purpose
    }
  })
}

export function getWeChatStatus(sceneStr) {
  return request({
    url: '/api/WeChatLogin/status',
    method: 'GET',
    params: {
      sceneStr
    }
  })
}

export function bindWeChat(data) {
  return request({
    url: '/api/WeChatLogin/bind',
    method: 'POST',
    data
  })
}

// Confirm WeChat binding
export function confirmWeChat(data) {
  return request({
    url: '/api/WeChatLogin/confirm',
    method: 'POST',
    data
  })
}
